'use-client';
import * as React from 'react';
import classNames from 'clsx';
import {
  formatClassNames,
  getDataAttributes,
} from '@wix/editor-elements-common-utils';
import type { IResponsivePopupContainerProps } from '../ResponsivePopupContainer.types';
import style from '../../ResponsivePopupPage/viewer/style/ResponsivePopupPage.scss';
import ResponsiveContainer from '../../../thunderbolt-core-components/ResponsiveContainer/viewer/ResponsiveContainer';
import { TestIds } from '../constants';
import semanticClassNames from '../ResponsivePopupContainer.semanticClassNames';
import { useEffect } from 'react';

const ResponsivePopupContainer: React.FC<
  IResponsivePopupContainerProps
> = props => {
  const {
    id,
    className,
    customClassNames = [],
    containerProps,
    containerRootClassName,
    children,
    onClick,
    onMouseEnter,
    onMouseLeave,
    setSiteScrollingBlocked,
    isDisableDocumentScrollWhenLightBoxOpenExperimentOpen,
  } = props;

  useEffect(() => {
    if (isDisableDocumentScrollWhenLightBoxOpenExperimentOpen) {
      setSiteScrollingBlocked(true, id);
    }

    return () => {
      if (isDisableDocumentScrollWhenLightBoxOpenExperimentOpen) {
        setSiteScrollingBlocked(false, id);
      }
    };
  }, [
    setSiteScrollingBlocked,
    isDisableDocumentScrollWhenLightBoxOpenExperimentOpen,
    id,
  ]);

  return (
    <div
      id={id}
      {...getDataAttributes(props)}
      className={classNames(className, containerRootClassName)}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      data-block-level-container="PopupContainer"
    >
      <div
        className={classNames(
          style.bg,
          formatClassNames(semanticClassNames.root, ...customClassNames),
        )}
        data-testid={TestIds.ResponsivePopupContainerBg}
      ></div>
      <ResponsiveContainer {...containerProps}>{children}</ResponsiveContainer>
    </div>
  );
};

export default ResponsivePopupContainer;
